<template>
  <div id="allstar">
    <div class="allstar">
      <div class="allstar_content">
        <h1>The Future Looks Bright</h1>
        <!-- <h2>Long Island, NY • 2026</h2> -->

        <div class="quote">
          <h3>
            During the 2025 NHL Draft, we selected three first-round picks,
            including the 1st overall pick Matthew Schaefer, 16th overall pick
            Victor Eklund, and 17th overall pick Kashawn Aitcheson.
          </h3>
          <h3>
            Our 2025 Draft class adds to our talented pipeline of prospects,
            including Cole Eiserman, Quinn Finley, Isaiah George, Danny Nelson,
            and Calum Ritchie.
          </h3>
          <!-- <h3>
            "The National Hockey League is thrilled to have the best and
            brightest of our game hosted at the spectacular UBS Arena"
          </h3>
          <h3>
            "We are comfortable and confident that we will have an event that
            people will like as a kickoff to going to the Olympics. And then
            we’ll come back and do a more hockey-focused competition event the
            following year.”
          </h3>
          <small>- NHL COMMISSIONER GARY BETTMAN</small> -->
        </div>

        <!-- <p>
          We are thrilled to be hosting the first of its kind Olympic Kickoff at
          UBS Arena in February of 2026!
        </p>
        <br />
        <p>
          The only way to secure access to the Olympic Kickoff is through an
          Islanders Season Ticket Membership, and Members will have priority
          access to purchase Olympic Kickoff tickets. Availability will be
          limited.
        </p> -->
      </div>
    </div>
  </div>
  <!-- </transition> -->
</template>

<script>
export default {
  name: "Allstar",

  setup() {
    return {};
  },
  methods: {},
};
// window.onscroll = function(ev) {
// 	var scroll = document.getElementById('scroll');
// 	if ((window.innerHeight + window.pageYOffset) >= document.body.offsetHeight) {
// 		scroll.classList.add("reverse");
// 	}
// 	else{
// 		scroll.classList.remove("reverse");
// 	}
// };
</script>
<style lang="scss" scoped>
.allstar {
  background-image: url("~images/allstar/draft.jpeg");
  background-position: center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 100px 0 221px;

  &::after {
    content: "";
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.6);
  }

  &_content {
    width: 95%;
    max-width: 924px;
    text-align: center;
    z-index: 1;

    img {
      width: 100%;
      max-width: 637px;
      margin-bottom: 77px;
    }

    h1 {
      color: #f26925;
      text-align: center;
      font-family: Prompt;
      font-size: 96px;
      font-style: normal;
      font-weight: 700;
      line-height: 88px; /* 91.667% */
      letter-spacing: -0.305px;
      margin-bottom: 30px;
      text-transform: uppercase;

      @media screen and (max-width: 789px) {
        font-size: 48px;
        line-height: 48px;
      }
    }

    h2 {
      color: #fff;
      text-align: center;
      font-family: Prompt;
      font-size: 48px;
      font-style: normal;
      font-weight: 400;
      line-height: 48px; /* 133.333% */
      margin-bottom: 77px;
      text-transform: uppercase;

      @media screen and (max-width: 789px) {
        font-size: 18px;
        line-height: 24px;
        margin-bottom: 37px;
      }
    }

    .quote {
      margin-bottom:0px;

      h3 {
        color: #fff;
        font-family: Prompt;
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: 36px;
        margin-bottom: 0;
        text-align: center;


        &:first-of-type {
          margin-bottom: 25px;
        }

        @media screen and (max-width: 789px) {
          font-size: 18px;
          line-height: 24px;
        }
      }
      small {
        color: #fff;
        font-family: Prompt;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 36px;
        margin-bottom: 0;

        @media screen and (max-width: 789px) {
          font-size: 16px;
          line-height: 24px;
        }
      }
    }

    p {
      color: #fff;
      font-family: Prompt;
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: 36px; /* 150% */
      margin-bottom: 0;
      text-align: left;

      @media screen and (max-width: 789px) {
        font-size: 18px;
        line-height: 24px;
      }
    }
  }
}
</style>
